// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4479":"e3f8bc33","5267":"e3f8bc33","6772":"d8eb0359"}[chunkId] + ".chunk.css";
};